import { render } from "./deals-transaction.vue?vue&type=template&id=482edd80&scoped=true"
import script from "./deals-transaction.vue?vue&type=script&lang=js"
export * from "./deals-transaction.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./deals-transaction.vue?vue&type=style&index=1&id=482edd80&scoped=true&lang=css"

import exportComponent from "D:\\SphinxProjects\\VUE3\\Excel_Library_Frontend_Website\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482edd80"]])

export default __exports__